import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
// eslint-disable-next-line max-len
import FallsAndHospitalizationSection from 'common/Print/components/FallsAndHospitalizationSection/FallsAndHospitalizationSection.component';
// eslint-disable-next-line max-len
import FallsAndHospitalizationStats from 'common/Print/components/FallsAndHospitalizationStats/FallsAndHospitalizationStats.component';
import { startCase } from 'lodash';
var FallsAndHospitalizationAssessmentTemplate = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a;
    return (_jsxs(Box, { "data-testid": 'fallsAndHospitalization-template', children: [data === null || data === void 0 ? void 0 : data.map(function (section) { return (_jsx(FallsAndHospitalizationSection, { heading: startCase(section.surveyName), data: section.surveyData }, section.surveyName)); }), _jsx(FallsAndHospitalizationStats, { data: data })] }));
};
export default FallsAndHospitalizationAssessmentTemplate;
